export const ENTITY_OBJECT_TYPES = {
  LOCATION: 'asset',
  ACCOUNT: 'contract',
  PEOPLE: 'party',
  SERVICE: 'service'
};
